import { Grid, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { BoxPropsType } from '../../Type';
// import { UNIT, calculateVolume } from '../../../../../services/calculateVolume';
import { createShipmentContextType } from '../../../../../types/shipment';
import CreateShipmentContext from '../../../../../context/CreateShipment';
import { BoxButton } from '../../../../GetRatesV2/StyleComponent';
// import { UNIT_OF_MEASUREMENT } from '../../../../GetRatesV2/Constant';
import Image from '../../../../../components/Image';
import { useSelector } from 'react-redux';
import { RootStateType } from '@Store';
import { customWeightRounding } from '../../../../../utils/convertWeight';

interface BoxDetailsPropsType extends BoxPropsType {
  setCopyBox: (copy: boolean) => void;
  isSelected: boolean;
  writePermission?: boolean;
  index: number;
}

function BoxDetails({ index, handleDeleteBox, boxData, isSelected, setCopyBox, writePermission }: BoxDetailsPropsType) {
  const { shipmentType, boxes, removeFirstBoxDeleteOption } = React.useContext(
    CreateShipmentContext,
  ) as createShipmentContextType;

  const { chareableWeight } = useSelector((state: RootStateType) => state.getRates);

  // const { id = '0', length, height, width } = boxData;
  const { id = '0' } = boxData;
  const weight = typeof boxData.weight === 'string' ? parseFloat(boxData.weight) : boxData.weight;

  const { unit, type } = shipmentType;

  const selectedUnit = useMemo(() => unit.split('-')[0], [unit]);

  return (
    <>
      <Grid container item justifyContent="space-between" alignItems="center">
        <Grid container justifyContent="space-between">
          <Grid container item xs={11} className="mb-1">
            <Typography className="md-text font-bold">{`Box ${parseInt(id) + 1} of ${boxes.length}`}</Typography>
          </Grid>
        </Grid>
        <BoxInfo label="Actual Weight" value={`${weight || 0} ${selectedUnit}`} />
        <BoxInfo
          label="Chargeable Weight"
          value={`${
            chareableWeight?.boxWiseArr
              ? `${
                  selectedUnit === 'lb'
                    ? customWeightRounding((chareableWeight?.boxWiseArr[index]?.minChargeableWeight ?? 0) * 2.20462)
                    : (Number(chareableWeight?.boxWiseArr[index]?.minChargeableWeight) ?? 0).toFixed(2)
                } - ${
                  selectedUnit === 'lb'
                    ? customWeightRounding((chareableWeight?.boxWiseArr[index]?.maxChargeableWeight ?? 0) * 2.20462)
                    : (Number(chareableWeight?.boxWiseArr[index]?.maxChargeableWeight) ?? 0).toFixed(2)
                }`
              : (0).toFixed(2)
          } ${selectedUnit}`}
        />

        <BoxInfo
          label="Volumetric Weight"
          value={`${
            chareableWeight?.boxWiseArr && chareableWeight?.boxWiseArr[index]?.maxVolumetricWeight
              ? selectedUnit === 'lb'
                ? (chareableWeight.boxWiseArr[index].maxVolumetricWeight * 2.20462).toFixed(2)
                : chareableWeight.boxWiseArr[index].maxVolumetricWeight.toFixed(2)
              : (0).toFixed(2)
          } ${selectedUnit}`}
        />
      </Grid>
      {/* {type === 'parcel' && ( */}
      <Grid container justifyContent="space-between" alignItems="center" columnSpacing={1}>
        <Grid item xs={6}>
          {id === '0' && removeFirstBoxDeleteOption ? (
            <></>
          ) : (
            <BoxButton
              onClick={handleDeleteBox}
              className={isSelected ? 'isSelected' : ''}
              startIcon={
                <Image
                  width={12}
                  src={`/images/Boxes/${boxes.length < 2 || type !== 'parcel' ? 'DeleteDisabled' : 'Delete'}.svg`}
                  alt="delete box"
                />
              }
              // style={{ cursor: boxes.length < 2 ? 'not-allowed' : 'pointer' }}
              disabled={!writePermission ? !writePermission : boxes.length < 2 || type !== 'parcel'}
            >
              Delete
            </BoxButton>
          )}
        </Grid>
        <Grid item xs={6}>
          <BoxButton
            onClick={() => setCopyBox(true)}
            className={isSelected ? 'isSelected' : ''}
            startIcon={
              <Image
                width={14}
                src={`/images/Boxes/${type !== 'parcel' ? 'CopyDisabled' : 'Copy'}.svg`}
                alt="duplicate box"
              />
            }
            disabled={!writePermission ? !writePermission : type !== 'parcel'}
          >
            Duplicate
          </BoxButton>
        </Grid>
      </Grid>
      {/* )} */}
    </>
  );
}

function BoxInfo({ value, label }: { label: string; value: string | number }) {
  return (
    <Grid container className="mb-1/2" display="grid" gridTemplateColumns="2fr 1fr" gap={1}>
      <Grid item>
        <Typography className="sm-text">{label}</Typography>
      </Grid>
      <Grid item textAlign="center">
        <Typography className="sm-text">{value}</Typography>
      </Grid>
    </Grid>
  );
}

export default BoxDetails;
